import * as React from 'react';
import { Dispatch } from 'redux';

import * as EntityNormalizers from '../normalizers/entityNormalizers';

import { BaseApiRequest } from './baseApiRequest';

export abstract class BaseApiPostRequest<
  ResponseType,
  ReturnType extends EntityNormalizers.NormalizedEntity<any>
> extends BaseApiRequest<ResponseType, ReturnType> {
  protected constructor(
    protected body: any,
    component: React.Component,
    dispatch: Dispatch,
    shouldDispatchError?: boolean,
  ) {
    super(component, dispatch, shouldDispatchError);
    this.method = 'POST';
  }

  protected generateRequest() {
    const request = super.generateRequest();
    request.body = JSON.stringify(this.body);

    return request;
  }
}
